import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mrt-traffic',
  standalone: true,
  template:`
  <div class="detail collapse {{ state }}" id="mrt">
    <div class="card card-body">
      <a (click)="close()" role="button" aria-expanded="false" aria-controls="mrt" class="bt-close">
        <span aria-hidden="true" class="close">×</span>
      </a>

      <div class="site-tt">站點資訊</div>

      <ul class="box mrt">
        <li class="titbox">
          <div class="m-title"><img src="/static/images/svg/map_w_mrt.svg" alt=""><p>捷運</p></div>
          <div class="s-title"><p>{{ name }}</p></div>
          <a role="button"><img src="/static/images/svg/ic_reset.svg" alt=""></a>
        </li>
        <li class="timelist">
          <div class="time">
            <div class="d-flex">
              <a href="https://www.tmrt.com.tw/metro-life/ride-time-and-fare" title="捷運(開啟新視窗)" target="_blank">進站時刻表</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  `
})


export class MrtTrafficComponent {
  @Input() name: string = '';
  @Output() callBack =  new EventEmitter<void>();
  state:string =""

  ngOnChanges(){
    this.state = "show"

  }
  close(){
    this.callBack.emit();
  }

}
